module.exports = __webpack_public_path__ + "static/success-banner-tablet-813ac2bb19409875ed6fe4ebb73303b4.jpg";